


































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Miembro from "../../models/miembro/miembro.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import BTableConfigDetailing from "../../core/BTableConfig/BTableConfigDetailing";
import Persona from "@/models/persona/persona.model";
import Usuario from "@/models/usuarios/usuario.model";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
@Component
export default class HistorialCambioJefes extends GenericBTable<Miembro> {
  @Prop() readonly codigoHogar!: string;

  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("codigoHogar", "string"));
    this.$emit("render", props);
    this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = "JefeHogarAntiguo";
    this.tableConfig.whereParams = this.getWhereParams();
    this.tableConfig.activeActions = false;
    this.tableConfig.loadOnMount = !!this.codigoHogar;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.include = "JefeAnterior|NuevoJefe";
    this.formatColumns();
  }
  formatColumns() {
    let anterior = new BTableColumn("jefeAnteriorId", "Antiguo jefe", false);
    anterior.customTemplate = true;
    anterior.templateSlot = "anterior";
    let nuevo = new BTableColumn("nuevoJefeId", "Sustituido por", false);
    nuevo.customTemplate = true;
    nuevo.templateSlot = "nuevo";
    let fecha = new BTableColumn("fechaDeCambio", "Fecha");
    fecha.type = BTableColumnType.DateTime;
    this.tableConfig.insertColumns(anterior, nuevo, fecha);
  }
  getPersona(id: number, nombre: string, cedula: string, foto: string) {
    let persona = new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }
  get hayHogar(){
    return !!this.codigoHogar;
  }
  @Watch("codigoHogar", { immediate: true })
  onPersonaIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.search();
  }

  searchText = "";
  getWhereParams() {
    let result = [];
    if (this.codigoHogar) result.push(`CodigoHogar="${this.codigoHogar}"`);
    return result.join("&&");
  }
  search() {
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
